import { Button, HelperText, TextInput } from "@enpowered/ui";
import { Field, Form, Formik } from "formik";
import PropTypes from "prop-types";
import React from "react";
import * as Yup from "yup";

const validationSchema = Yup.object({
  accountName: Yup.string().required("Account name is required."),
  utilityName: Yup.string().required("Utility name is required."),
  accountFormat: Yup.string().required("Account format is required."),
  ldcNumber: Yup.string().required("LDC Account Number."),
  accountType: Yup.string().required("Account type is required."),
  postalCode: Yup.string().required("Postal code is required.")
});

const AddBillModal = ({ onSubmit, onCancel }) => {
  return (
    <div>
      <Formik
        onSubmit={onSubmit}
        initialValues={{
          accountName: "",
          utilityName: "",
          accountFormat: "",
          ldcNumber: "",
          accountType: "",
          postalCode: ""
        }}
        validationSchema={validationSchema}
      >
        {() => (
          <Form className="px-4 pt-4">
            <div>
              <Field name="accountName">
                {({
                  field, // { name, value, onChange, onBlur }
                  meta
                }) => {
                  const isValid = !(meta.error && meta.touched);
                  return (
                    <>
                      <TextInput
                        className={isValid ? "pb-6" : ""}
                        placeholder="Account Name"
                        {...field}
                        valid={isValid}
                      />
                      {!isValid && (
                        <HelperText valid={false}>{meta.error}</HelperText>
                      )}
                    </>
                  );
                }}
              </Field>

              <Field name="utilityName">
                {({ field, meta }) => {
                  const isValid = !(meta.error && meta.touched);
                  return (
                    <>
                      <TextInput
                        className={isValid ? "pb-6" : ""}
                        placeholder="Utility Name"
                        {...field}
                        valid={isValid}
                      />
                      {!isValid && (
                        <HelperText valid={false}>{meta.error}</HelperText>
                      )}
                    </>
                  );
                }}
              </Field>

              <Field name="accountFormat">
                {({ field, meta }) => {
                  const isValid = !(meta.error && meta.touched);
                  return (
                    <>
                      <TextInput
                        className={isValid ? "pb-6" : ""}
                        placeholder="Account Format"
                        {...field}
                        valid={isValid}
                      />
                      {!isValid && (
                        <HelperText valid={false}>{meta.error}</HelperText>
                      )}
                    </>
                  );
                }}
              </Field>

              <Field name="ldcNumber">
                {({ field, meta }) => {
                  const isValid = !(meta.error && meta.touched);
                  return (
                    <>
                      <TextInput
                        className={isValid ? "pb-6" : ""}
                        placeholder="LDC Account Number"
                        {...field}
                        valid={isValid}
                      />
                      {!isValid && (
                        <HelperText valid={false}>{meta.error}</HelperText>
                      )}
                    </>
                  );
                }}
              </Field>

              <Field name="accountType">
                {({ field, meta }) => {
                  const isValid = !(meta.error && meta.touched);
                  return (
                    <>
                      <TextInput
                        className={isValid ? "pb-6" : ""}
                        placeholder="Account Type"
                        {...field}
                        valid={isValid}
                      />
                      {!isValid && (
                        <HelperText valid={false}>{meta.error}</HelperText>
                      )}
                    </>
                  );
                }}
              </Field>

              <Field name="postalCode">
                {({ field, meta }) => {
                  const isValid = !(meta.error && meta.touched);
                  return (
                    <>
                      <TextInput
                        className={isValid ? "pb-6" : ""}
                        placeholder="Postal Code"
                        {...field}
                        valid={isValid}
                      />
                      {!isValid && (
                        <HelperText valid={false}>{meta.error}</HelperText>
                      )}
                    </>
                  );
                }}
              </Field>
            </div>

            <div className="flex justify-between">
              <Button
                type="reset"
                theme=""
                className="bg-white text-black border border-gray-800 rounded mr-4"
                onClick={onCancel}
                size="narrow"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                theme=""
                className="bg-black text-white"
                size="narrow"
              >
                Submit
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

AddBillModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default AddBillModal;
